import 'config/axios'
import 'config/jquery' // remove all backbone and jquery calls before removal!
import 'common/log'
import 'config/bluebird'
import 'config/moment'
import 'common/globals'
import 'common/CustomCss'

import _ from 'lodash';
import React from 'react';
import {AppModuleType} from 'common/AppModule'
import {AppBoundary} from 'component/AppBoundary';
import {AnyAction, applyMiddleware, compose, legacy_createStore as createStore, Store} from 'redux';
import {combineEpics, createEpicMiddleware, EpicMiddleware} from 'redux-observable';
import {appInitAction} from "util/ReduxUtil";
import {commonEpics, commonProperties, commonReducers} from 'common/CommonBase';
import {loadUpgradedStateFromLocalStorage} from 'util/redux/ReduxStateUtil';
import combineReducers from 'combine-reducers-global-state/lib';
import {appReady} from 'common/appReady';
import {isDebugEnabled, isTraceEnabled, log} from 'common/log';
import {catchError, ignoreElements, tap} from 'rxjs/operators';
import localforage from 'localforage'
import {PayloadAction} from 'util/redux'
import {adaptV4Theme} from '@mui/material/styles';
import {createRoot} from 'react-dom/client'

window.sis = {
	...window.sis,
	_,
	localforage: localforage,
	adaptV4Theme, // for adapting custom theme
	debug() {
		_.assign(window, window.sis);
	},
};

interface AppInitResult {
	store: Store
	epicMiddleware: EpicMiddleware<PayloadAction>
}

//deferred usage because imports are using appInitialized and entryPoint initializes the app.
let _resolveAppInit: (value: AppInitResult | Promise<AppInitResult>) => void;
export const appInitialized = new Promise<AppInitResult>(res => _resolveAppInit = res);

export function initReactApp(AppModule: AppModuleType, isAdditionalContent?: boolean) {
	const {App, reducers, epics, properties, actions} = AppModule;
	const composeEnhancers = window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

	const epicMiddleware = createEpicMiddleware();

	const storePromise = appReady
		.then(() => loadUpgradedStateFromLocalStorage())
		.then(lastState => {
			const store = createStore(
				combineReducers({...reducers, ...commonReducers}),
				lastState,
				composeEnhancers(
					applyMiddleware(epicMiddleware),
				),
			);

			if (isTraceEnabled()) {
				epicMiddleware.run(action$ => action$.pipe(
					tap((action: AnyAction) => console.log(new Date().toISOString(), 'redux action', action.type, action)),
					ignoreElements(),
				))
			}

			epicMiddleware.run((action$, state$, dependencies) =>
				combineEpics(...epics, ...commonEpics)(action$, state$, dependencies).pipe(
					catchError(err => {
						log.error('Uncaught error in epics!', err)
						setTimeout(() => {
							if (confirm('Uncaught error!\n\nDie Applikation muss neu geladen werden, damit sie wieder funktioniert.')) {
								window.document.location.reload()
							}
						}, 100)
						return []
					}),
				))

			if (isDebugEnabled()) window.sis = {...window.sis, store}

			store.dispatch(appInitAction({properties: [...properties, ...commonProperties]}));

			actions.forEach(action => store.dispatch(action));

			return store;
		})

	_resolveAppInit(
		storePromise.then((store) => {
			const rootEl = document.getElementById('ReactRoot')
			if (!rootEl) {
				log.error('missing ReactRoot HTML Element')
				return;
			} else {
				const root = createRoot(rootEl);
				root.render(<AppBoundary store={store} isAdditionalContent={isAdditionalContent}>
					<App/>
				</AppBoundary>);
			}
			return {store, epicMiddleware};
		}).catch((...err) => console.error(...err)) as Promise<AppInitResult>,
	)
}